import React, { useState } from 'react';
import { ClipboardList, ClipboardCheck } from 'lucide-react';
import { usePermissions } from '@hooks/usePermissions';
import { StockMovementListView } from './StockMovementListView';
import { InventorySessionListView } from '../inventorySessions/InventorySessionListView';
import { clsx } from 'clsx';

type TabId = 'movements' | 'inventory';

interface Tab {
  id: TabId;
  label: string;
  icon: React.ReactNode;
  permission: string;
}

const TABS: Tab[] = [
  { id: 'movements', label: 'Conferência de Estoque', icon: <ClipboardList size={16} />, permission: 'stock_movements.read' },
  { id: 'inventory', label: 'Inventário de Estoque', icon: <ClipboardCheck size={16} />, permission: 'stock_movements.read' },
];

export const StockMovementsPageView: React.FC = () => {
  const { checkPermission } = usePermissions();
  const [activeTab, setActiveTab] = useState<TabId>('movements');

  const availableTabs = TABS.filter(tab => checkPermission(tab.permission).hasPermission);
  const effectiveTab = availableTabs.find(t => t.id === activeTab) ? activeTab : (availableTabs[0]?.id ?? 'movements');

  return (
    <div className="space-y-6">
      {/* Tabs */}
      {availableTabs.length > 1 && (
        <div className="border-b border-slate-200">
          <nav className="flex -mb-px gap-0" aria-label="Abas de conferência e inventário">
            {availableTabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={clsx(
                  'inline-flex items-center gap-2 whitespace-nowrap py-3 px-5 text-sm font-medium border-b-2 transition-colors',
                  effectiveTab === tab.id
                    ? 'border-emerald-500 text-emerald-600'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300',
                )}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      )}

      {/* Tab content */}
      {effectiveTab === 'movements' && <StockMovementListView />}
      {effectiveTab === 'inventory' && <InventorySessionListView />}
    </div>
  );
};
